import { render, staticRenderFns } from "./TransferStation.vue?vue&type=template&id=ba220d4e&scoped=true&"
import script from "./TransferStation.vue?vue&type=script&lang=js&"
export * from "./TransferStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba220d4e",
  null
  
)

export default component.exports